import { useState, useEffect, Fragment } from "react";
import { Link } from "react-router-dom";
import Swiper from "react-id-swiper";
import "./StylesPalisade.css"
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Image from "react-bootstrap/Image";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faDownload,
    faCar,
    faChevronLeft,
    faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { Helmet } from 'react-helmet';
/**** Fotos Banner ****/
import Slider1 from "../../images/modelos/palisade/banner/banner1.webp";
import Slider2 from "../../images/modelos/palisade/banner/banner2.webp";
import Slider3 from "../../images/modelos/palisade/banner/banner3.webp";
import Slider4 from "../../images/modelos/palisade/banner/banner4.webp";
import Slider5 from "../../images/modelos/palisade/banner/banner5.webp";
/****Fotos calidad de tiempo ****/
import Calidad from "../../images/modelos/palisade/calidad/calidad-de-tiempo 2.webp";
import Felicidad from "../../images/modelos/palisade/calidad/calidad-de-tiempo-3.webp";
import Exclusivo from "../../images/modelos/palisade/calidad/calidad-de-tiempo-4.webp";
import Galeria1 from "../../images/modelos/palisade/calidad/galeria1.webp";
import Galeria2 from "../../images/modelos/palisade/calidad/galeria2.webp";
import Galeria3 from "../../images/modelos/palisade/calidad/galeria3.webp";
import Galeria4 from "../../images/modelos/palisade/calidad/galeria4.webp";
import Galeria5 from "../../images/modelos/palisade/calidad/galeria5.webp";
import Galeria6 from "../../images/modelos/palisade/calidad/galeria6.webp";
import Galeria7 from "../../images/modelos/palisade/calidad/galeria7.webp";
import Galeria8 from "../../images/modelos/palisade/calidad/galeria8.webp";
/****Fotos disenio ****/
import Exterior from "../../images/modelos/palisade/disenio/exterior/exterior.webp";
import Exterior1 from "../../images/modelos/palisade/disenio/exterior/exterior1.webp";
import Exterior2 from "../../images/modelos/palisade/disenio/exterior/exterior2.webp";
import Exterior3 from "../../images/modelos/palisade/disenio/exterior/exterior3.webp";
import Exterior4 from "../../images/modelos/palisade/disenio/exterior/exterior4.webp";
import Exterior5 from "../../images/modelos/palisade/disenio/exterior/exterior5.webp";
import Exterior6 from "../../images/modelos/palisade/disenio/exterior/exterior6.webp";
import Interior from "../../images/modelos/palisade/disenio/interior/interior.webp";
import Interior1 from "../../images/modelos/palisade/disenio/interior/interior1.webp";
import Interior2 from "../../images/modelos/palisade/disenio/interior/interior2.webp";
import Interior3 from "../../images/modelos/palisade/disenio/interior/interior3.webp";
import Interior4 from "../../images/modelos/palisade/disenio/interior/interior4.webp";
import Interior5 from "../../images/modelos/palisade/disenio/interior/interior5.webp";
import Interior6 from "../../images/modelos/palisade/disenio/interior/interior6.webp";

/****Fotos rendimiento ****/
import Rendimiento from "../../images/modelos/palisade/rendimiento/rendimiento.webp";
import Rendmiento1 from "../../images/modelos/palisade/rendimiento/rendimiento1.webp";
import Rendmiento2 from "../../images/modelos/palisade/rendimiento/rendimiento2.webp";
import Rendmiento3 from "../../images/modelos/palisade/rendimiento/rendimiento3.webp";

/****Fotos seguridad ****/
import Seguridad from "../../images/modelos/palisade/seguridad/seguridad.webp";
import Seguridad1 from "../../images/modelos/palisade/seguridad/seguridad1.webp";
import Seguridad2 from "../../images/modelos/palisade/seguridad/seguridad2.webp";
import Seguridad3 from "../../images/modelos/palisade/seguridad/seguridad3.webp";
import Seguridad4 from "../../images/modelos/palisade/seguridad/seguridad4.webp";
import Seguridad5 from "../../images/modelos/palisade/seguridad/seguridad5.webp";

/****Fotos conveniencia ****/
import Conveniencia1 from "../../images/modelos/palisade/conveniencia/conveniencia1.webp";
import Conveniencia2 from "../../images/modelos/palisade/conveniencia/conveniencia2.webp";
import Conveniencia3 from "../../images/modelos/palisade/conveniencia/conveniencia3.webp";
import Conveniencia4 from "../../images/modelos/palisade/conveniencia/conveniencia4.webp";
import Conveniencia5 from "../../images/modelos/palisade/conveniencia/conveniencia5.webp";
import Conveniencia6 from "../../images/modelos/palisade/conveniencia/conveniencia6.webp";
/****Ficha técnica ****/
import PalisadeCatalogo from "../../fichas/palisade-brochure.pdf";

function InfoPalisade() {
    const [gallerySwiper, getGallerySwiper] = useState(null);
    const [thumbnailSwiper, getThumbnailSwiper] = useState(null);

    const gallerySwiperParams = {
        getSwiper: getGallerySwiper,
        loop: true,
        loopedSlides: 5, //looped slides should be the same
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
    };

    const thumbnailSwiperParams = {
        getSwiper: getThumbnailSwiper,
        slidesPerView: 5,
        loop: true,
        freeMode: true,
        loopedSlides: 5, //looped slides should be the same
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        slideToClickedSlide: true,
        centeredSlides: true,
    };

    useEffect(() => {
        if (
            gallerySwiper !== null &&
            gallerySwiper.controller &&
            thumbnailSwiper !== null &&
            thumbnailSwiper.controller
        ) {
            gallerySwiper.controller.control = thumbnailSwiper;
            thumbnailSwiper.controller.control = gallerySwiper;
        }
    }, [gallerySwiper, thumbnailSwiper]);

    const onChangeMenu = (menu) => {
        switch (menu) {
            case "calidad":
                document.getElementById("tab-calidad").className = "color-hover";
                document.getElementById("tab-disenio").className = "color-normal";
                document.getElementById("tab-rendimiento").className = "color-normal";
                document.getElementById("tab-seguridad").className = "color-normal";
                document.getElementById("tab-conveniencia").className = "color-normal";
                document.getElementById("calidad").className = "d-block";
                document.getElementById("disenio").className = "d-none";
                document.getElementById("rendimiento").className = "d-none";
                document.getElementById("seguridad").className = "d-none";
                document.getElementById("conveniencia").className = "d-none";
                document.getElementById("img-carrusel").src = Slider1;
                break;
            case "disenio":
                document.getElementById("tab-calidad").className = "color-normal";
                document.getElementById("tab-disenio").className = "color-hover";
                document.getElementById("tab-rendimiento").className = "color-normal";
                document.getElementById("tab-seguridad").className = "color-normal";
                document.getElementById("tab-conveniencia").className = "color-normal";
                document.getElementById("calidad").className = "d-none";
                document.getElementById("disenio").className = "d-block";
                document.getElementById("rendimiento").className = "d-none";
                document.getElementById("seguridad").className = "d-none";
                document.getElementById("conveniencia").className = "d-none";
                document.getElementById("img-carrusel").src = Slider2;
                break;
            case "rendimiento":
                document.getElementById("tab-calidad").className = "color-normal";
                document.getElementById("tab-disenio").className = "color-normal";
                document.getElementById("tab-rendimiento").className = "color-hover";
                document.getElementById("tab-seguridad").className = "color-normal";
                document.getElementById("tab-conveniencia").className = "color-normal";
                document.getElementById("calidad").className = "d-none";
                document.getElementById("disenio").className = "d-none";
                document.getElementById("rendimiento").className = "d-block";
                document.getElementById("seguridad").className = "d-none";
                document.getElementById("conveniencia").className = "d-none";
                document.getElementById("img-carrusel").src = Slider3;
                break;
            case "seguridad":
                document.getElementById("tab-calidad").className = "color-normal";
                document.getElementById("tab-disenio").className = "color-normal";
                document.getElementById("tab-rendimiento").className = "color-normal";
                document.getElementById("tab-seguridad").className = "color-hover";
                document.getElementById("tab-conveniencia").className = "color-normal";
                document.getElementById("calidad").className = "d-none";
                document.getElementById("disenio").className = "d-none";
                document.getElementById("rendimiento").className = "d-none";
                document.getElementById("seguridad").className = "d-block";
                document.getElementById("conveniencia").className = "d-none";
                document.getElementById("img-carrusel").src = Slider4;
                break;
            case "conveniencia":
                document.getElementById("tab-calidad").className = "color-normal";
                document.getElementById("tab-disenio").className = "color-normal";
                document.getElementById("tab-rendimiento").className = "color-normal";
                document.getElementById("tab-seguridad").className = "color-normal";
                document.getElementById("tab-conveniencia").className = "color-hover";
                document.getElementById("calidad").className = "d-none";
                document.getElementById("disenio").className = "d-none";
                document.getElementById("rendimiento").className = "d-none";
                document.getElementById("seguridad").className = "d-none";
                document.getElementById("conveniencia").className = "d-block";
                document.getElementById("img-carrusel").src = Slider5;
                break;
            default:
                break;
        }
    };

    return (
        <Fragment>
            <Container fluid={true}>
                <Row>
                    <Col md={12} className="px-0">
                        <Helmet>
                            <link rel="preload" href={Slider1} as="image" />
                        </Helmet>
                        <div className="palisade-banner-container">
                            <Image
                                src={Slider1}
                                alt="Palisade Banner"
                                className="palisade-banner"
                                id="img-carrusel"
                                fluid
                            />
                        </div>
                    </Col>
                </Row>
            </Container>
            <div className="menu-vehiculo sticky-top">
                <Container>
                    <Row className="py-2 py-md-4">
                        <Col xs={2} md={2} className="my-auto d-none d-sm-block">
                            <h1 className="menu-modelo">PALISADE</h1>
                        </Col>
                        <Col
                            xs={12}
                            md={6}
                            className="my-auto vehiculo-item text-md-center px-0"
                        >
                            <ul className="my-auto p-0 m-0">
                                <li
                                    id="tab-calidad"
                                    onClick={() => onChangeMenu("calidad")}
                                    className="color-hover"
                                >
                                    Calidad de tiempo
                                </li>
                                <li
                                    id="tab-disenio"
                                    onClick={() => onChangeMenu("disenio")}
                                    className="color-normal"
                                >
                                    Diseño
                                </li>
                                <li
                                    id="tab-rendimiento"
                                    onClick={() => onChangeMenu("rendimiento")}
                                    className="color-normal"
                                >
                                    Rendimiento
                                </li>
                                <li
                                    id="tab-seguridad"
                                    onClick={() => onChangeMenu("seguridad")}
                                    className="color-normal"
                                >
                                    Seguridad
                                </li>
                                <li
                                    id="tab-conveniencia"
                                    onClick={() => onChangeMenu("conveniencia")}
                                    className="color-normal"
                                >
                                    Conveniencia
                                </li>
                            </ul>
                        </Col>
                        <Col xs={3} md={1} className="text-center my-auto cont-extra">
                            <a
                                href="static/media/palisade-ficha-tecnica.pdf"
                                className="text-reset text-decoration-none"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <FontAwesomeIcon icon={faDownload} />
                                <span className="menu-extra"> Ficha</span>
                            </a>
                        </Col>
                        <Col xs={3} md={1} className="text-center my-auto cont-extra px-1">
                            <a
                                href={PalisadeCatalogo}
                                className="text-reset text-decoration-none"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <FontAwesomeIcon icon={faDownload} />
                                <span className="menu-extra"> Catálogo</span>
                            </a>
                        </Col>
                        <Col xs={3} md={1} className="text-center my-auto cont-extra px-1">
                            <Link
                                to="/cotizador/palisade"
                                className="text-reset text-decoration-none"
                            >
                                <FontAwesomeIcon icon={faCar} />
                                <span className="menu-extra"> Cotizar</span>
                            </Link>
                        </Col>
                        <Col xs={3} md={1} className="text-center my-auto cont-extra px-1">
                            <Link
                                to="/test-drive/palisade"
                                className="text-reset text-decoration-none"
                            >
                                <FontAwesomeIcon icon={faCar} />
                                <span className="menu-extra">Test Drive</span>
                            </Link>
                        </Col>
                    </Row>
                </Container>
            </div>
            {/***************************************** calidad ***************************************/}
            <section id="calidad">
                <Container className="py-4 py-md-5">
                    <Row>
                        <Col md={12} className="text-center">
                            <h2 className="model-title">PALISADE HYBRID</h2>
                            <p className="model-text mb-md-5 mt-3 px-3 px-md-0">
                                El Palisade Hybrid es el SUV full-size que redefine lo que significa haber llegado lejos.
                                Con un diseño exterior renovado, imponente y sofisticado, tecnología de vanguardia y un nivel de confort premium, está pensado para quienes no se conforman con lo que ya lograron.
                                Porque después de todo lo que has recorrido, mereces un vehículo que esté a la altura de tu camino.
                            </p>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={12} className="bg-black py-2 px-2 py-md-4 px-md-0">
                            <Image src={Calidad} alt="Palisade Calidad" className="img-calidad" fluid />
                        </Col>
                    </Row>
                </Container>
                <div className="bg-landing">
                    <Container>
                        <Row className="py-3 py-md-5">
                            <Col md={6} className="my-auto order-2 order-md-1">
                                <h3 className="model-title mt-4 pt-2 px-3 px-md-0">
                                    DISEÑO RENOVADO Y PRESENCIA QUE IMPONE
                                </h3>
                                <p className="specs-text px-3 px-md-0">
                                    Parrilla con detalles Cromados y Piano-black, iluminación full LED y aros de 21” con
                                    llantas Pirelli.
                                </p>
                            </Col>
                            <Col md={6} className="my-auto order-1 order-md-2">
                                <Image src={Felicidad} alt="Palisade Rendimiento" className="img-paladise3" fluid />
                            </Col>
                        </Row>
                        <Row className="py-3 py-md-5">
                            <Col md={6} className="my-auto">
                                <Image src={Exclusivo} alt="Palisade Poderoso" className="img-paladise3" fluid />
                            </Col>
                            <Col md={6} className="my-auto">
                                <h3 className="model-title mt-4 pt-2 px-3 px-md-0">
                                    TECNOLOGÍA Y CONFORT DE UNA NUEVA GENERACIÓN
                                </h3>
                                <p className="specs-text px-3 px-md-0">
                                    Pantalla digital de 12.3”, sistema BOSE de 14 parlantes y conectividad total.
                                </p>
                                <p className="specs-text px-3 px-md-0">
                                    SmartSense con cámara 360° y asistentes avanzados de seguridad.
                                </p>
                            </Col>
                        </Row>
                    </Container>
                </div>
                <Container>
                    <Row className="py-3 py-md-5">
                        <Col md={12} className="text-center">
                            <h2 className="galeria-titulo my-3 pb-2 pb-md-4">Galería</h2>
                            <div>
                                <Swiper {...gallerySwiperParams}>
                                    <div>
                                        <LazyLoadImage
                                            src={Galeria1}
                                            alt="Palisade Slider 1"
                                            className="img-galeria1"
                                        />
                                    </div>
                                    <div>
                                        <Image
                                            src={Galeria2}
                                            alt="Palisade Slider 2"
                                            className="img-galeria1"
                                        />
                                    </div>
                                    <div>
                                        <Image
                                            src={Galeria3}
                                            alt="Palisade Slider 3"
                                            className="img-galeria1"
                                        />
                                    </div>
                                    <div>
                                        <Image
                                            src={Galeria4}
                                            alt="Palisade Slider 4"
                                            className="img-galeria1"
                                        />
                                    </div>
                                    <div>
                                        <Image
                                            src={Galeria5}
                                            alt="Palisade Slider 5"
                                            className="img-galeria1"
                                        />
                                    </div>
                                    <div>
                                        <Image
                                            src={Galeria6}
                                            alt="Palisade Slider 6"
                                            className="img-galeria1"
                                        />
                                    </div>
                                    <div>
                                        <Image
                                            src={Galeria7}
                                            alt="Palisade Slider 7"
                                            className="img-galeria1"
                                        />
                                    </div>
                                    <div>
                                        <Image
                                            src={Galeria8}
                                            alt="Palisade Slider 8"
                                            className="img-galeria1"
                                        />
                                    </div>
                                </Swiper>
                                <Swiper {...thumbnailSwiperParams}>
                                    <div>
                                        <Image
                                            src={Galeria1}
                                            alt="Palisade Slider 1"
                                            className="img-galeria2"
                                        />
                                    </div>
                                    <div>
                                        <Image
                                            src={Galeria2}
                                            alt="Palisade Slider 2"
                                            className="img-galeria2"
                                        />
                                    </div>
                                    <div>
                                        <Image
                                            src={Galeria3}
                                            alt="Palisade Slider 3"
                                            className="img-galeria2"
                                        />
                                    </div>
                                    <div>
                                        <Image
                                            src={Galeria4}
                                            alt="Palisade Slider 4"
                                            className="img-galeria2"
                                        />
                                    </div>
                                    <div>
                                        <Image
                                            src={Galeria5}
                                            alt="Palisade Slider 5"
                                            className="img-galeria2"
                                        />
                                    </div>
                                    <div>
                                        <Image
                                            src={Galeria6}
                                            alt="Palisade Slider 6"
                                            className="img-galeria2"
                                        />
                                    </div>
                                    <div>
                                        <Image
                                            src={Galeria7}
                                            alt="Palisade Slider 7"
                                            className="img-galeria2"
                                        />
                                    </div>
                                    <div>
                                        <Image
                                            src={Galeria8}
                                            alt="Palisade Slider 8"
                                            className="img-galeria2"
                                        />
                                    </div>
                                </Swiper>
                            </div>
                        </Col>
                    </Row>
                </Container>
                <div className="bg-landing">
                    <Container>
                        <Row className="py-3 py-md-5">
                            <Col xs={6} md={6}></Col>
                            <Col xs={6} md={6} className="text-right">
                                <span
                                    onClick={() => onChangeMenu("disenio")}
                                    className="titulo-navegacion"
                                >
                                    Diseño
                                    <FontAwesomeIcon
                                        icon={faChevronRight}
                                        className="ml-2 ml-md-3"
                                    />
                                </span>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </section>
            {/***************************************** disenio ***************************************/}
            <section id="disenio" className="d-none">
                <Container className="py-4 py-md-5">
                    <Row>
                        <Col md={12} className="text-center">
                            <h2 className="model-title mb-0">ELEGANCIA QUE IMPONE</h2>
                            <p className="model-text mt-3 px-3 px-md-0">
                                El Palisade Hybrid transmite autoridad desde el primer momento.
                            </p>
                            <p className="model-text mt-3 px-3 px-md-0">
                                Su presencia se impone con precisión. Cada línea y proporción fue
                                diseñada para proyectar sofisticación, fuerza y una seguridad que
                                se siente incluso antes de conducirlo.
                            </p>
                            <p className="model-text mt-3 px-3 px-md-0">
                                Pensado para destacar desde la sutileza, este SUV encuentra el equilibrio
                                perfecto entre lo funcional y lo emocional. Su postura amplia, la nueva parrilla
                                paramétrica, la iluminación full LED y los aros de 21” crean una estética firme,
                                moderna y estilizada que acompaña a quienes avanzan sin detenerse.
                            </p>
                            <p className="model-text mt-3 px-3 px-md-0">
                                Porque elevar tus estándares también es elegir un diseño que hable por ti,
                                incluso cuando no dices una palabra.
                            </p>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={12} className="text-center mb-3 mb-md-5">
                            <h2 className="model-title mb-0">EXTERIOR</h2>
                            <Image
                                src={Exterior}
                                alt="Exterior"
                                fluid
                            />
                            <p className="model-text mt-3 px-3 px-md-0">
                                Una presencia que se reconoce al instante. Su frente completamente renovado,
                                con parrilla paramétrica y detalles en piano black, junto a su iluminación full LED,
                                proyecta carácter desde cualquier ángulo. Las luces traseras conectadas completan una
                                silueta sólida, moderna y diseñada para destacar en cualquier entorno.
                            </p>
                            <p className="model-text mt-3 px-3 px-md-0">
                                Cada línea transmite poder. Cada detalle eleva la estética.
                            </p>
                            <p className="model-text mt-3 px-3 px-md-0">
                                Este SUV combina robustez y sofisticación con una claridad absoluta: está hecho para
                                personas que no siguen el camino, lo elevan.
                            </p>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={12} className="px-0">
                            <Row>
                                <Col md={4} className="mt-3 mt-md-4">
                                    <Image src={Exterior1} alt="Palisade Espejos" fluid />
                                    <h3 className="specs-subtitle-sm mt-3 px-3 px-md-0">
                                        Aros de 21” con llantas Pirelli.
                                    </h3>
                                </Col>
                                <Col md={4} className="mt-3 mt-md-4">
                                    <Image src={Exterior2} alt="Palisade Manijas" fluid />
                                    <h3 className="specs-subtitle-sm mt-3 px-3 px-md-0">
                                        Parrilla renovada.
                                    </h3>
                                </Col>
                                <Col md={4} className="mt-3 mt-md-4">
                                    <Image src={Exterior3} alt="Palisade Manijas" fluid />
                                    <h3 className="specs-subtitle-sm mt-3 px-3 px-md-0">
                                        Faros delanteros full LED.
                                    </h3>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={4} className="mt-3 mt-md-4">
                                    <Image src={Exterior4} alt="Palisade Espejos" fluid />
                                    <h3 className="specs-subtitle-sm mt-3 px-3 px-md-0">
                                        Antena tipo aleta de tiburón.
                                    </h3>
                                </Col>
                                <Col md={4} className="mt-3 mt-md-4">
                                    <Image src={Exterior5} alt="Palisade Manijas" fluid />
                                    <h3 className="specs-subtitle-sm mt-3 px-3 px-md-0">
                                        Faros posteriores LED conectados.
                                    </h3>
                                </Col>
                                <Col md={4} className="mt-3 mt-md-4">
                                    <Image src={Exterior6} alt="Palisade Manijas" fluid />
                                    <h3 className="specs-subtitle-sm mt-3 px-3 px-md-0">
                                        Rieles de carga en el techo.
                                    </h3>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Container>
                <div className="bg-landing">
                    <Container>
                        <Row className="pt-3 pt-md-5">
                            <Col md={12} className="text-center">
                                <h2 className="model-title-sub">Interior</h2>
                                <p className="specs-text mt-3 px-3 px-md-0">
                                    Todo su interior está pensado para ofrecer una experiencia de conducción superior. 
                                    Sus tres filas de asientos forrados en cuero Nappa, junto a la pantalla panorámica 
                                    curva de 12.3”, crean un ambiente de lujo, amplitud y total conectividad.
                                </p>
                                <p className="specs-text pb-md-4 px-3 px-md-0">
                                    Los asientos, los materiales y la distribución refuerzan la sensación de espacio. 
                                    Aquí cada detalle existe para elevar tu comodidad: ventilación, calefacción, 
                                    función de masaje para el conductor y una arquitectura interior diseñada para que 
                                    disfrutes el trayecto con absoluta claridad y control.
                                </p>
                                <Image src={Interior} alt="Palisade Interior" fluid />
                            </Col>
                        </Row>
                        <Row className="pb-3 pb-md-2 mt-4">
                            <Col md={4} className="mt-3 mt-md-4">
                                <Image src={Interior1} alt="Palisade Pantalla tactil" fluid />
                                <h3 className="specs-text mt-3 px-3 px-md-0">
                                    Pantalla panorámica curva de 12.3” con Apple CarPlay / Android Auto
                                </h3>
                            </Col>
                            <Col md={4} className="mt-3 mt-md-4">
                                <Image src={Interior2} alt="Palisade Tablero" fluid />
                                <h3 className="specs-text mt-3 px-3 px-md-0">
                                    Asientos delanteros eléctricos con calefacción, ventilación y masaje.
                                </h3>
                            </Col>
                            <Col md={4} className="mt-3 mt-md-4">
                                <Image src={Interior3} alt="Palisade Volante" fluid />
                                <h3 className="specs-text mt-3 px-3 px-md-0">
                                    Segunda fila deslizables, reclinables y con ventilación.
                                </h3>
                            </Col>
                        </Row>
                        <Row className="pb-3 pb-md-2 mt-4">
                            <Col md={4} className="mt-3 mt-md-4">
                                <Image src={Interior4} alt="Palisade memoria asientos" fluid />
                                <h3 className="specs-text mt-3 px-3 px-md-0">
                                    Volante multifunción con reconocimiento de voz.
                                </h3>
                            </Col>
                            <Col md={4} className="mt-3 mt-md-4">
                                <Image src={Interior5} alt="Palisade cargador inalambrico" fluid />
                                <h3 className="specs-text mt-3 px-3 px-md-0">
                                    Iluminación interior LED con luz ambiental.
                                </h3>
                            </Col>
                            <Col md={4} className="mt-3 mt-md-4">
                                <Image src={Interior6} alt="Camara de retro" fluid />
                                <h3 className="specs-text mt-3 px-3 px-md-0">
                                    Sunroof panorámico doble.
                                </h3>
                            </Col>
                        </Row>
                    </Container>
                </div>
                <div className="bg-landing">
                    <Container>
                        <Row className="py-3 py-md-5">
                            <Col xs={6} md={6} className="text-left">
                                <span
                                    onClick={() => onChangeMenu("calidad")}
                                    className="titulo-navegacion"
                                >
                                    <FontAwesomeIcon
                                        icon={faChevronLeft}
                                        className="mr-2 mr-md-3"
                                    />
                                    Calidad de tiempo
                                </span>
                            </Col>
                            <Col xs={6} md={6} className="text-right">
                                <span
                                    onClick={() => onChangeMenu("rendimiento")}
                                    className="titulo-navegacion"
                                >
                                    Rendimiento
                                    <FontAwesomeIcon
                                        icon={faChevronRight}
                                        className="ml-2 ml-md-3"
                                    />
                                </span>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </section>
            {/***************************************** rendimiento ***************************************/}
            <section id="rendimiento" className="d-none">
                <Container className="py-4 py-md-5">
                    <Row>
                        <Col md={12} className="text-center">
                            <h2 className="model-title">
                                TU CAMINO, ELEVADO.
                            </h2>
                            <p className="model-text mb-md-5 mt-3 px-3 px-md-0">
                                Hecho para acompañarte con un rendimiento que se siente sólido, preciso y siempre disponible.
                            </p>
                            <p className="model-text mb-md-5 mt-3 px-3 px-md-0">
                                Su motor híbrido de 329 HP responde con potencia cuando lo necesitas y mantiene estabilidad 
                                incluso en los trayectos más exigentes.
                            </p>
                            <p className="model-text mb-md-5 mt-3 px-3 px-md-0">
                                Gracias a sus modos de manejo y a una conducción afinada para el confort, 
                                moverse con el Palisade se siente natural.
                            </p>
                            <p className="model-text mb-md-5 mt-3 px-3 px-md-0">
                                Eres tú quien marca el ritmo, el terreno y el momento. Porque avanzar también significa exigir 
                                desempeño sin renunciar a eficiencia.
                            </p>
                        </Col>
                    </Row>
                    <Row className="d-flex justify-content-center mt-3 pb-3 pb-md-4">
                        <Col md={4} className="mt-4 mt-md-4">
                            <Image src={Rendmiento1} alt="Palisade Motor" fluid />
                            <h3 className="specs-text mt-3">
                                Motor híbrido 2.5L con 329 HP.
                            </h3>
                        </Col>
                        <Col md={4} className="mt-4 mt-md-4">
                            <Image src={Rendmiento2} alt="Palisade suspension" fluid />
                            <h3 className="specs-text mt-3">
                                Suspensión Multi-Link para mayor estabilidad.
                            </h3>
                        </Col>
                        <Col md={4} className="mt-4 mt-md-4">
                            <Image src={Rendmiento3} alt="Palisade modos de conduccion" fluid />
                            <h3 className="specs-text mt-3">
                                Modos de conducción: Eco, Comfort, Sport y Smart.
                            </h3>
                        </Col>
                    </Row>
                    <Row className="mt-4 mt-md-5">
                        <Col md={12}>
                            <Image
                                src={Rendimiento}
                                alt="Palisade Banner"
                                className="w-100"
                                fluid
                            />
                        </Col>
                    </Row>
                </Container>
                <div className="bg-landing">
                    <Container>
                        <Row className="py-3 py-md-5">
                            <Col xs={6} md={6} className="text-left">
                                <span
                                    onClick={() => onChangeMenu("disenio")}
                                    className="titulo-navegacion"
                                >
                                    <FontAwesomeIcon
                                        icon={faChevronLeft}
                                        className="mr-2 mr-md-3"
                                    />
                                    Diseño
                                </span>
                            </Col>
                            <Col xs={6} md={6} className="text-right">
                                <span
                                    onClick={() => onChangeMenu("seguridad")}
                                    className="titulo-navegacion"
                                >
                                    Seguridad
                                    <FontAwesomeIcon
                                        icon={faChevronRight}
                                        className="ml-2 ml-md-3"
                                    />
                                </span>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </section>
            {/***************************************** seguridad ***************************************/}
            <section id="seguridad" className="d-none">
                <Container className="py-4 py-md-5">
                    <Row>
                        <Col md={12} className="text-center">
                            <h2 className="model-title">
                                SEGURIDAD QUE SE ADELANTA A TI
                            </h2>
                            <p className="model-text mb-md-5 mt-3 px-3 px-md-0">
                                Equipado para brindarte seguridad en cada momento del trayecto. 
                                Con asistentes avanzados Hyundai SmartSense, siete airbags y una 
                                visión completa gracias a la cámara 360°, te permite moverte con 
                                tranquilidad tanto en ciudad como en carretera.
                            </p>
                            <p className="model-text mb-md-5 mt-3 px-3 px-md-0">
                                Desde el monitoreo de punto ciego hasta el frenado autónomo, cada sistema 
                                trabaja en segundo plano para que tomes el control con confianza, sabiendo 
                                que estás respaldado en cada maniobra.
                            </p>
                        </Col>
                    </Row>
                    <Row className="mt-md-4 d-flex justify-content-center">
                        <Col md={6} className="mt-4 text-center">
                            <Image src={Seguridad1} alt="Palisade proyeccion pantalla" fluid />
                            <h3 className="specs-subtitle-bold mt-3">
                                7 Airbags.
                            </h3>
                        </Col>
                        <Col md={6} className="mt-4 text-center">
                            <Image src={Seguridad2} alt="Palisade Punto Ciego" fluid />
                            <h3 className="specs-subtitle-bold mt-3">
                                Asistente de mantenimiento y centrado de carril (LKA / LFA).
                            </h3>
                        </Col>
                    </Row>
                    <Row className="mt-md-4 d-flex justify-content-center">
                        <Col md={4} className="mt-4 text-center">
                            <Image src={Seguridad3} alt="Palisade proyeccion pantalla" fluid />
                            <h3 className="specs-subtitle-bold mt-3">
                                Monitor de punto ciego con cámara (BCA).
                            </h3>
                        </Col>
                        <Col md={4} className="mt-4 text-center">
                            <Image src={Seguridad4} alt="Palisade Punto Ciego" fluid />
                            <h3 className="specs-subtitle-bold mt-3">
                                Cámara 360° con guías dinámicas.
                            </h3>
                        </Col>
                        <Col md={4} className="mt-4 text-center">
                            <Image src={Seguridad5} alt="Palisade Radar" fluid />
                            <h3 className="specs-subtitle-bold mt-3">
                                Control electrónico de estabilidad (ESC).
                            </h3>
                        </Col>
                    </Row>
                    <Row className="pt-3 pb-3 pb-md-5">
                        <Col md={12} className="mx-auto text-center">
                            <Image
                                src={Seguridad}
                                alt="Palisade Calificacion"
                                className="px-5"
                                fluid
                            />
                        </Col>
                    </Row>
                </Container>
                <div className="bg-landing">
                    <Container>
                        <Row className="py-3 py-md-5">
                            <Col xs={6} md={6} className="text-left">
                                <span
                                    onClick={() => onChangeMenu("rendimiento")}
                                    className="titulo-navegacion"
                                >
                                    <FontAwesomeIcon
                                        icon={faChevronLeft}
                                        className="mr-2 mr-md-3"
                                    />
                                    Rendimiento
                                </span>
                            </Col>
                            <Col xs={6} md={6} className="text-right">
                                <span
                                    onClick={() => onChangeMenu("conveniencia")}
                                    className="titulo-navegacion"
                                >
                                    Conveniencia
                                    <FontAwesomeIcon
                                        icon={faChevronRight}
                                        className="ml-2 ml-md-3"
                                    />
                                </span>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </section>
            {/***************************************** conveniencia ***************************************/}
            <section id="conveniencia" className="d-none">
                <Container className="py-4 py-md-5">
                    <Row>
                        <Col md={12} className="text-center">
                            <h2 className="model-title">
                                Tecnología que se adapta a ti
                            </h2>
                            <p className="model-text mb-md-3 mt-3 px-3 px-md-0">
                                Pensado para simplificar cada momento. Su interior combina confort, conectividad y 
                                soluciones intuitivas, para que cada trayecto fluya desde el primer instante.
                            </p>
                            <p className="model-text mb-md-3 mt-3 px-3 px-md-0">
                                Desde el arranque con botón hasta los detalles que suman comodidad, 
                                como los puertos USB para todas las filas, el cargador inalámbrico y 
                                el acceso inteligente al maletero, todo está diseñado para que disfrutes 
                                sin interrupciones.
                            </p>
                        </Col>
                    </Row>
                </Container>
                <div className="bg-landing">
                    <Container>
                        <Row className="py-3 py-md-5">
                            <Col md={4} className="mt-4 text-center">
                                <Image
                                    src={Conveniencia1}
                                    alt="Palisade mandos integrados volante"
                                    fluid
                                />
                                <h3 className="specs-text mt-3 px-3 px-md-0">
                                    Cámara 360°.
                                </h3>
                            </Col>
                            <Col md={4} className="mt-4 text-center">
                                <Image
                                    src={Conveniencia2}
                                    alt="Palisade puertos traseros usb"
                                    fluid
                                />
                                <h3 className="specs-text mt-3 px-3 px-md-0">
                                    Asientos movibles.
                                </h3>
                            </Col>
                            <Col md={4} className="mt-4 text-center">
                                <Image src={Conveniencia3} alt="Palisade entrada plegada" fluid />
                                <h3 className="specs-text mt-3 px-3 px-md-0">
                                    Apertura eléctrica del maletero con manos libres.
                                </h3>
                            </Col>
                        </Row>
                        <Row className="py-3 py-md-5">
                            <Col md={4} className="mt-4 text-center">
                                <Image
                                    src={Conveniencia4}
                                    alt="Palisade mandos integrados volante"
                                    fluid
                                />
                                <h3 className="specs-text mt-3 px-3 px-md-0">
                                    Cargadores USB-C para todas las filas.
                                </h3>
                            </Col>
                            <Col md={4} className="mt-4 text-center">
                                <Image
                                    src={Conveniencia5}
                                    alt="Palisade puertos traseros usb"
                                    fluid
                                />
                                <h3 className="specs-text mt-3 px-3 px-md-0">
                                    Climatización inteligente para pasajeros traseros.
                                </h3>
                            </Col>
                            <Col md={4} className="mt-4 text-center">
                                <Image src={Conveniencia6} alt="Palisade entrada plegada" fluid />
                                <h3 className="specs-text mt-3 px-3 px-md-0">
                                    Bandejas, portavasos y espacios de guardado.
                                </h3>
                            </Col>
                        </Row>
                    </Container>
                </div>
                <div className="bg-landing">
                    <Container>
                        <Row className="py-3 py-md-5">
                            <Col xs={6} md={6} className="text-left">
                                <span
                                    onClick={() => onChangeMenu("seguridad")}
                                    className="titulo-navegacion"
                                >
                                    <FontAwesomeIcon
                                        icon={faChevronLeft}
                                        className="mr-2 mr-md-3"
                                    />
                                    Seguridad
                                </span>
                            </Col>
                            <Col xs={6} md={6}></Col>
                        </Row>
                    </Container>
                </div>
            </section>
        </Fragment>
    );
}
export default InfoPalisade;